function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath = []) {
  return routes.map((route, index) => {
    const treePath = [...parentPath, String(index)];
    const id = typeof route.id === "string" ? route.id : treePath.join("-");
    route.id = id;
    if (isIndexRoute(route)) {
      const indexRoute = {
        ...route,
        ...mapRouteProperties(route),
        id
      };
      return indexRoute;
    } else {
      const pathOrLayoutRoute = {
        ...route,
        ...mapRouteProperties(route),
        id,
        children: void 0
      };
      if (route.children) {
        pathOrLayoutRoute.children = convertRoutesToDataRoutes(
          route.children,
          mapRouteProperties,
          treePath
          // manifest,
        );
      }
      return pathOrLayoutRoute;
    }
  });
}
function isIndexRoute(route) {
  return route.index === true;
}

export { convertRoutesToDataRoutes as c };
